<template>
	<slot />
</template>

<script setup>

</script>

<style scoped>

</style>
